import React, {PropTypes} from 'react';
import StandardModal from 'shared/StandardModal.jsx';

const TournamentRequirementModal = ({
  visible,
  age,
  onCancel
}) =>(
  <StandardModal
    title={`Tournament Requirement`}
    visible={visible}
    onCloseClick={onCancel}>
      <div>
        <div>
            <p>{`The tournament requires you to be ${age} years old to register. `}</p>
        </div>
        <div className="form-group text-right"> 
            <button
            onClick={() => onCancel()}
            className="btn btn-primary btn-lg"
            ><i className="fa fa-floppy-o" /> {'OK'}</button>
        </div>
      </div>
    </StandardModal>
);

TournamentRequirementModal.propTypes = {
    visible: PropTypes.bool,
    age: PropTypes.number,
    onCancel: PropTypes.func
};

TournamentRequirementModal.defaultProps = {
    visible: false,
    age: 0
};

export default TournamentRequirementModal;


// WEBPACK FOOTER //
// ./src/features/registration/home/TournamentRequirementModal.jsx